import React, { useState } from 'react';
import Image from 'next/image';
import { useRouter } from 'next/router';

import { hooks } from '@/domains/number-sale';
import { ErrorModal, InformationBlock, ScreenLoader } from '@/components/ui';
import { downloadBlobFile } from '@/utils/downloadBlobFile';
import { PaymentStatus } from '@/enums/numberSale';

interface IProps {
  data: {
    id: number;
    type: string;
    success_icon: string;
    success_title: string;
    success_description: string;
    success_button_icon: string;
    success_button_text: string;
    success_button_type: string;
    success_button_slug: string;
    success_button_download_file: string;
    success_button_scroll_to: string;
    error_icon: string;
    error_title: string;
    error_description: string;
    error_button_icon: string;
    error_button_text: string;
    error_button_type: string;
    error_button_slug: string;
    error_button_download_file: string;
    error_button_scroll_to: string;
  };
}

export const SuccessBanner: React.FC<IProps> = ({ data }) => {
  const [getContract, { error, isFetching }] = hooks.useGetLazyNumberContract();
  const [showError, setShowError] = useState(false);

  const router = useRouter();
  const { paymentStatus } = router.query;
  const isSuccess = paymentStatus === PaymentStatus.SUCCESS;

  const clickHandler = async () => {
    if (isSuccess) {
      try {
        const trackId =
          typeof window !== 'undefined'
            ? sessionStorage.getItem('nsTrackId')
            : null;

        if (!trackId) {
          throw new Error('Track ID not found in localStorage');
        }
        const data: Blob = await getContract({
          trackId,
        }).unwrap();
        downloadBlobFile(data, 'Contract.pdf');
      } catch (error) {
        setShowError(true);
      }
    } else {
      router.push('/home');
    }
  };

  return (
    <div className='section' itemScope itemType='https://schema.org/Alret'>
      <div className='wrapper'>
        <ScreenLoader visible={isFetching} />
        <InformationBlock
          icon={
            isSuccess &&
            data?.success_icon && (
              <Image
                src={data?.success_icon}
                alt={data?.success_title}
                title={data?.success_title}
                width={60}
                height={60}
              />
            )
          }
          secondary={false}
          content={{
            title: isSuccess ? data?.success_title : data?.error_title,
            text: isSuccess
              ? data?.success_description
              : data?.error_description,
            buttonText: isSuccess
              ? data?.success_button_text
              : data?.error_button_text,
            buttonIcon: isSuccess && data?.success_button_icon,
          }}
          onClick={clickHandler}
        />
        <ErrorModal
          active={showError}
          icon='/assets/error.png'
          setActive={() => {
            setShowError(false);
          }}
        >
          {error?.message}
        </ErrorModal>
      </div>
    </div>
  );
};
